var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLock = function SvgIconLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-890 -834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88,305H48v40H88Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.646,327.946a4.5,4.5,0,0,0,6.709,0H72.5a3,3,0,0,0,0-6H71.354a4.5,4.5,0,0,0-6.709,0H63.5a3,3,0,0,0,0,6Zm5.218-1.334a2.5,2.5,0,0,1-3.728,0l-.6-.666H63.5a1,1,0,0,1,0-2h2.04l.6-.666a2.5,2.5,0,0,1,3.728,0l.6.666H72.5a1,1,0,0,1,0,2H70.46Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56,325a12,12,0,1,0,12-12A12,12,0,0,0,56,325Zm12,10a10,10,0,1,1,10-10A10,10,0,0,1,68,335Z",
    transform: "translate(842 529)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lock.41bd4205.svg";
export { ForwardRef as ReactComponent };